import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CognitoServiceService } from './cognito-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private cognito: CognitoServiceService) { }

  /**
   * @desc To check whether the current user is loggedIn or not and redirect based on the result
   * @returns boolean
   */
  canActivate(): boolean {
    // Checking whether user loggedIn or not using cognito service
    if (this.cognito.getAuthenticatedUser()) {
      return true;
    } else {
      // If user is not loggedIn, navigating him to login/signup page
      this.router.navigate(['/login']);
      return false;
    }
  }

}
